import { PaginatedResponse } from  "@/interfaces/api/PaginatedResponse";
import { IHttpRequest } from  "@/interfaces/IHttp";
import { container, TYPES } from  "@/inversifyconfig/container.config";
import { IBasicGroup, IUserData, IUserPermission} from  '@/interfaces/orgSettings';
import { IUserWorkspaceData } from  "@/interfaces/workspaces";

const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 
           
export async function getOrganisationRoleForUser(userId: any): Promise<any> {
    const url = `users/${userId}/permission`        
    const res = await http.get(url);

    if(res) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get user group data`))
}

export async function setOrganisationRoleForUser(userId: any, params:any): Promise<IUserPermission> {
    const url = `users/${userId}/permission`    
    const res = await http.put(url, params);

    if(res) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't update the user role`))
}

export async function getAllUsers(params: any, options?: { signal?: AbortSignal }): Promise<PaginatedResponse<IUserData>> {
    const url = `users`    

    try {
        const res = await http.get(url, { params, signal: options?.signal});

        if (res) {
            return Promise.resolve(res.data);
        }
    } catch (error) {
        throw error;
    }
}


export async function getAllUsersForWorkspace(appId: string, params:any, options?: { signal?: AbortSignal }): Promise<PaginatedResponse<IUserData>> {
    const url = `apps/${appId}/users`    
    try{
        const res = await http.get(url, { params, signal: options?.signal});

        if(res) {
            return Promise.resolve(res.data)
        } 
    } catch (error) {
        throw error;
    }
}

export async function getAllUsersForGroup(groupId: string, params:any, options?: { signal?: AbortSignal }): Promise<PaginatedResponse<IUserData>> {
    const url = `groups/${groupId}/users`  
 
    try{
        const res = await http.get(url, { params, signal: options?.signal});

        if(res) {
            return Promise.resolve(res.data)
        } 
    } catch (error) {
        throw error;
    }
}

export async function getAllUsersAvailableToAdd(groupId: string, params:any, options?: { signal?: AbortSignal }): Promise<PaginatedResponse<IUserData>> {
    const url = `groups/${groupId}/users/availableToAdd`;    
    try{
        const res = await http.get(url, { params, signal: options?.signal});

        if(res) {
            return Promise.resolve(res.data)
        } 
    } catch (error) {
        throw error;
    }
}

export async function getGroupListForUser(appId: any, userId:any): Promise<IBasicGroup> {
    const url = `apps/${appId}/users/${userId}/groups`    
    const res = await http.get(url);

    if(res) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get user group data`))
}

export async function getOrganisationGroupListForUser(userId:any): Promise<IBasicGroup> {
    const url = `users/${userId}/groups`    
    const res = await http.get(url);

    if(res) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get user group data`))
}

export async function getWorkspacesForUser(userId: any, params:any): Promise<PaginatedResponse<IUserWorkspaceData>> {
    const url = `users/${userId}/apps`    
    const res = await http.get(url, {params});

    if(res) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get workspace data`))
}

export async function addUserToOrganisationGroup(userId: any, userGroupId:any) {
    const url = `groups/${userGroupId}/users/${userId}`    
    const res = await http.put(url, "");

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Couldn't add user to group`))
}

export async function removeUserFromOrganisationGroup(userId: any, userGroupId:any) {
    const url = `groups/${userGroupId}/users/${userId}`    

    const res = await http.delete(url);
    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Couldn't remove user from group`))
}
